import { render } from "./bind_reduction_positions.vue?vue&type=template&id=206b0840"
import script from "./bind_reduction_positions.vue?vue&type=script&lang=js"
export * from "./bind_reduction_positions.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/reduction/comerc/bind_reduction_positions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "206b0840"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('206b0840', __exports__)) {
    console.log('reload')
    api.reload('206b0840', __exports__)
  }
  
  module.hot.accept("./bind_reduction_positions.vue?vue&type=template&id=206b0840", () => {
    console.log('re-render')
    api.rerender('206b0840', render)
  })

}


export default __exports__